export default __webpack_public_path__ + "static/media/Sexy.5b2a9cbe.png";